import * as React from "react";
const SvgBackArrowWhite = props => <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} viewBox="0 0 18 18" {...props}><path d="M9 1 1 9l8 8M1 9h16" /></svg>;
export default SvgBackArrowWhite;